import React from "react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import NavBar from "./components/NavBar";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import {AboutNatasha} from "./components/AboutNatasha";

export const App = () => {
    return (
        <div id="home">
            <Header />
            <NavBar />
            <HeroSection />
            <AboutNatasha />
            <ContactForm />
            <Footer />
        </div>
    );
};

